import { render, staticRenderFns } from "./profileInsight.vue?vue&type=template&id=0ccc56c6&scoped=true"
import script from "./profileInsight.vue?vue&type=script&lang=js"
export * from "./profileInsight.vue?vue&type=script&lang=js"
import style0 from "./profileInsight.vue?vue&type=style&index=0&id=0ccc56c6&prod&scoped=true&lang=css"
import style1 from "./profileInsight.vue?vue&type=style&index=1&id=0ccc56c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc56c6",
  null
  
)

export default component.exports